import { combineReducers, configureStore } from "@reduxjs/toolkit";

import authReducer from "../features/auth/authSlice";
import chatReducer from "../features/chat/chatSlice";
import conversationCacheReducer from "../features/chat/conversationCacheSlice";
import controlReducer from "../features/control/controlSlice";
import detailsReducer from "../features/details/detailsSlice";
import settingsReducer from "../features/settings/settingsSlice";
import websocketMiddleware from "./websocketMiddleware";

export const store = configureStore({
  reducer: {
    chat: chatReducer,
    conversationCache: conversationCacheReducer,
    auth: authReducer,
    control: controlReducer,
    details: detailsReducer,
    settings: settingsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(websocketMiddleware),
});

const rootReducer = combineReducers({
  chat: chatReducer,
  conversationCache: conversationCacheReducer,
  auth: authReducer,
  control: controlReducer,
  details: detailsReducer,
  settings: settingsReducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(websocketMiddleware),
    preloadedState,
  });
};

export type RootState = ReturnType<typeof store.getState>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
